import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const MeadowHeightsCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Meadow Heights" suburbSlug="meadow-heights" variant="cdbs-dentist" />
);

export default MeadowHeightsCdbsDentistPage;
